function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = [
    "groupId",
    "children"
];
import * as React from 'react';
import { isLeaf } from "../../../models/gridColumnGrouping.js";
import { gridColumnGroupsLookupSelector, gridColumnGroupsUnwrappedModelSelector } from "./gridColumnGroupsSelector.js";
import { useGridApiMethod } from "../../utils/useGridApiMethod.js";
import { getColumnGroupsHeaderStructure, unwrapGroupingColumnModel } from "./gridColumnGroupsUtils.js";
import { useGridApiEventHandler } from "../../utils/useGridApiEventHandler.js";
import { gridColumnFieldsSelector, gridVisibleColumnFieldsSelector } from "../columns/index.js";
var createGroupLookup = function(columnGroupingModel) {
    var groupLookup = {};
    columnGroupingModel.forEach(function(node) {
        if (isLeaf(node)) {
            return;
        }
        var groupId = node.groupId, children = node.children, other = _objectWithoutPropertiesLoose(node, _excluded);
        if (!groupId) {
            throw new Error('MUI X: An element of the columnGroupingModel does not have either `field` or `groupId`.');
        }
        if (process.env.NODE_ENV !== 'production') {
            if (!children) {
                console.warn("MUI X: group groupId=".concat(groupId, " has no children."));
            }
        }
        var groupParam = _extends({}, other, {
            groupId: groupId
        });
        var subTreeLookup = createGroupLookup(children);
        if (subTreeLookup[groupId] !== undefined || groupLookup[groupId] !== undefined) {
            throw new Error("MUI X: The groupId ".concat(groupId, " is used multiple times in the columnGroupingModel."));
        }
        groupLookup = _extends({}, groupLookup, subTreeLookup, _define_property({}, groupId, groupParam));
    });
    return _extends({}, groupLookup);
};
export var columnGroupsStateInitializer = function(state, props, apiRef) {
    var _Math;
    if (!props.columnGroupingModel) {
        return state;
    }
    var columnFields = gridColumnFieldsSelector(apiRef);
    var visibleColumnFields = gridVisibleColumnFieldsSelector(apiRef);
    var _props_columnGroupingModel;
    var groupLookup = createGroupLookup((_props_columnGroupingModel = props.columnGroupingModel) !== null && _props_columnGroupingModel !== void 0 ? _props_columnGroupingModel : []);
    var _props_columnGroupingModel1;
    var unwrappedGroupingModel = unwrapGroupingColumnModel((_props_columnGroupingModel1 = props.columnGroupingModel) !== null && _props_columnGroupingModel1 !== void 0 ? _props_columnGroupingModel1 : []);
    var _apiRef_current_state_pinnedColumns;
    var columnGroupsHeaderStructure = getColumnGroupsHeaderStructure(columnFields, unwrappedGroupingModel, (_apiRef_current_state_pinnedColumns = apiRef.current.state.pinnedColumns) !== null && _apiRef_current_state_pinnedColumns !== void 0 ? _apiRef_current_state_pinnedColumns : {});
    var maxDepth = visibleColumnFields.length === 0 ? 0 : (_Math = Math).max.apply(_Math, _to_consumable_array(visibleColumnFields.map(function(field) {
        var _unwrappedGroupingModel_field;
        var _unwrappedGroupingModel_field_length;
        return (_unwrappedGroupingModel_field_length = (_unwrappedGroupingModel_field = unwrappedGroupingModel[field]) === null || _unwrappedGroupingModel_field === void 0 ? void 0 : _unwrappedGroupingModel_field.length) !== null && _unwrappedGroupingModel_field_length !== void 0 ? _unwrappedGroupingModel_field_length : 0;
    })));
    return _extends({}, state, {
        columnGrouping: {
            lookup: groupLookup,
            unwrappedGroupingModel: unwrappedGroupingModel,
            headerStructure: columnGroupsHeaderStructure,
            maxDepth: maxDepth
        }
    });
};
/**
 * @requires useGridColumns (method, event)
 * @requires useGridParamsApi (method)
 */ export var useGridColumnGrouping = function(apiRef, props) {
    /**
   * API METHODS
   */ var getColumnGroupPath = React.useCallback(function(field) {
        var unwrappedGroupingModel = gridColumnGroupsUnwrappedModelSelector(apiRef);
        var _unwrappedGroupingModel_field;
        return (_unwrappedGroupingModel_field = unwrappedGroupingModel[field]) !== null && _unwrappedGroupingModel_field !== void 0 ? _unwrappedGroupingModel_field : [];
    }, [
        apiRef
    ]);
    var getAllGroupDetails = React.useCallback(function() {
        var columnGroupLookup = gridColumnGroupsLookupSelector(apiRef);
        return columnGroupLookup;
    }, [
        apiRef
    ]);
    var columnGroupingApi = {
        getColumnGroupPath: getColumnGroupPath,
        getAllGroupDetails: getAllGroupDetails
    };
    useGridApiMethod(apiRef, columnGroupingApi, 'public');
    var handleColumnIndexChange = React.useCallback(function() {
        var _props_columnGroupingModel;
        var unwrappedGroupingModel = unwrapGroupingColumnModel((_props_columnGroupingModel = props.columnGroupingModel) !== null && _props_columnGroupingModel !== void 0 ? _props_columnGroupingModel : []);
        apiRef.current.setState(function(state) {
            var _state_columns;
            var _state_columns_orderedFields;
            var orderedFields = (_state_columns_orderedFields = (_state_columns = state.columns) === null || _state_columns === void 0 ? void 0 : _state_columns.orderedFields) !== null && _state_columns_orderedFields !== void 0 ? _state_columns_orderedFields : [];
            var _state_pinnedColumns;
            var pinnedColumns = (_state_pinnedColumns = state.pinnedColumns) !== null && _state_pinnedColumns !== void 0 ? _state_pinnedColumns : {};
            var columnGroupsHeaderStructure = getColumnGroupsHeaderStructure(orderedFields, unwrappedGroupingModel, pinnedColumns);
            return _extends({}, state, {
                columnGrouping: _extends({}, state.columnGrouping, {
                    headerStructure: columnGroupsHeaderStructure
                })
            });
        });
    }, [
        apiRef,
        props.columnGroupingModel
    ]);
    var updateColumnGroupingState = React.useCallback(function(columnGroupingModel) {
        var _Math;
        var _apiRef_current_getPinnedColumns, _apiRef_current;
        var _apiRef_current_getPinnedColumns1;
        // @ts-expect-error Move this logic to `Pro` package
        var pinnedColumns = (_apiRef_current_getPinnedColumns1 = (_apiRef_current_getPinnedColumns = (_apiRef_current = apiRef.current).getPinnedColumns) === null || _apiRef_current_getPinnedColumns === void 0 ? void 0 : _apiRef_current_getPinnedColumns.call(_apiRef_current)) !== null && _apiRef_current_getPinnedColumns1 !== void 0 ? _apiRef_current_getPinnedColumns1 : {};
        var columnFields = gridColumnFieldsSelector(apiRef);
        var visibleColumnFields = gridVisibleColumnFieldsSelector(apiRef);
        var groupLookup = createGroupLookup(columnGroupingModel !== null && columnGroupingModel !== void 0 ? columnGroupingModel : []);
        var unwrappedGroupingModel = unwrapGroupingColumnModel(columnGroupingModel !== null && columnGroupingModel !== void 0 ? columnGroupingModel : []);
        var columnGroupsHeaderStructure = getColumnGroupsHeaderStructure(columnFields, unwrappedGroupingModel, pinnedColumns);
        var maxDepth = visibleColumnFields.length === 0 ? 0 : (_Math = Math).max.apply(_Math, _to_consumable_array(visibleColumnFields.map(function(field) {
            var _unwrappedGroupingModel_field;
            var _unwrappedGroupingModel_field_length;
            return (_unwrappedGroupingModel_field_length = (_unwrappedGroupingModel_field = unwrappedGroupingModel[field]) === null || _unwrappedGroupingModel_field === void 0 ? void 0 : _unwrappedGroupingModel_field.length) !== null && _unwrappedGroupingModel_field_length !== void 0 ? _unwrappedGroupingModel_field_length : 0;
        })));
        apiRef.current.setState(function(state) {
            return _extends({}, state, {
                columnGrouping: {
                    lookup: groupLookup,
                    unwrappedGroupingModel: unwrappedGroupingModel,
                    headerStructure: columnGroupsHeaderStructure,
                    maxDepth: maxDepth
                }
            });
        });
    }, [
        apiRef
    ]);
    useGridApiEventHandler(apiRef, 'columnIndexChange', handleColumnIndexChange);
    useGridApiEventHandler(apiRef, 'columnsChange', function() {
        updateColumnGroupingState(props.columnGroupingModel);
    });
    useGridApiEventHandler(apiRef, 'columnVisibilityModelChange', function() {
        updateColumnGroupingState(props.columnGroupingModel);
    });
    /**
   * EFFECTS
   */ React.useEffect(function() {
        updateColumnGroupingState(props.columnGroupingModel);
    }, [
        updateColumnGroupingState,
        props.columnGroupingModel
    ]);
};
